<template>
<div>
    <base-header type="gradient-info" class="pb-6 pb-8 pt-5 pt-md-8"></base-header>
    <BlockUI v-if="loader.busy">
        <div class="loader"></div>
    </BlockUI>
    <div class="container-fluid mt--7 mb-5">
        <div class="row">
            <div class="col-12 col-md-12 col-lg-12 col-xl-12 m-auto">
                <card shadow type="secondary">
                    <div slot="header" class="bg-white border-0">
                        <div class="row align-items-center">
                            <div class="col-8">
                                <h3 class="mb-0" v-if="isEdit()">แก้ไขข้อมูลขนส่ง</h3>
                                <h3 class="mb-0" v-else>เพิ่มข้อมูลขนส่ง</h3>
                            </div>
                        </div>
                    </div>
                        <template>
                            <DetailsCourier
                                ref="detailsCourier"
                                :inputCourier="inputCourier"
                                :validateData="validateData"
                                :isEdit="isEdit()"
                                @checkCourierKeys="checkCourierKeys"
                                @selectCourierList="selectCourierList"
                                @handleLoader="handleLoader"
                                :isWho="isWho()"
                                :valueFromOwner="inputCourier.from_courier_inter"
                            />
                            <hr class="my-4" />
                        </template>
                    <div class="row justify-content-end">
                        <div class="col-4 col-md-4 col-lg-4 col-xl-2">
                            <button type="button" class="btn btn-secondary btn-block btn-icon py-3" @click="reloadPage()">คืนค่า
                            </button>
                        </div>
                        <div class="col-4 col-md-4 col-lg-4 col-xl-2">
                            <button 
                                :disabled="!auth0RoleUsage('transportinteredit')"
                                type="button" 
                                class="btn btn-success btn-block btn-icon py-3" 
                                @click="checkBtnConfirmData()"
                            >ยืนยัน</button>
                        </div>
                    </div>
                </card>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import { createRateExcel }  from '@/helpers/excelGenerator'
import CourierRules from '@/constants/CourierRules'
import { courierDetail as _COURIERS_ } from '@/config/courierCodes'
import configPOPTheme from '@/config/POPTheme'
import moment from 'moment'
import DetailsCourier  from '@/components/custom/transport/inter/DetailsCourier'
import { auth0RoleUsage } from "@/helpers/auth0"
import { getCourierInterById } from "@/axios/courier.js";
import { showConfirmSuccessModal , showErrorModal } from "@/components/modalNotification.js";
const API_URL = process.env.VUE_APP_API;
export default {
    data() {
        return {
            loader: {
                busy: false
            },
            permission: {
                table: {
                    min: {
                        disabled: false
                    },
                    max: {
                        disabled: false
                    },
                    dimension: {
                        show: false,
                        disabled: false
                    },
                    cost: {
                        show: false,
                        disabled: false
                    },
                    rate: {
                        show: false,
                        disabled: false
                    }
                },
                userLogin: "",
                isGen: false,
                samePage: false
            },
            rateError: {},
            inputCourier: {
                selectCourierType: null,
                selectCourier: null,
                from_courier_inter: [],
                disable_edit_rate: false,
                allowedCourier: [],
                price: 0,
                price_min: 0,
                rate_max_discount: 0,
                service_min: 0,
                service: 0,
                rate_min: 0,
                rate: 0,
                descriptionCouier: "",
                courierName: "",
                courierKey: '',
                effective_date: (['shippop','superadmin','admin'].includes(this.isWho()))?moment().format('YYYY-MM-DDTHH:mm'):'',
                expired_date: "",
                nameOfPic: "",
            },
            courierCheck: {
                shippopCourierKeys: CourierRules.shippopCourierKeys, 
                extraCouriers: CourierRules.extraCouriers,
                dimension: CourierRules.dimensionCouriers
            },
            priceTableStyle: this.isWho() == 'shippop' ?'show_price':(configPOPTheme.priceTableStyle || 'show_price'),
            validateData: {
                submitted: false,
                btnComfirm: false,
                checkInput: {
                    courierKey: null
                }
            },
            auth0RoleUsage:auth0RoleUsage
        }
    },
    beforeCreate() {
        this.userLogin = JSON.parse(localStorage.getItem("user"));
    },
    mounted() {
        if (this.isEdit()) {
            this.getCourierByIdAndRole()
        } else if (!this.isEdit() && this.isWho() == 'admin') {
            this.$refs.detailsCourier.adminGetDefaultCouriers()
        }
        // } else if (this.isEdit() && this.isWho() == 'admin') {
        //     this.adminGetCourierForUpdate();
        // } else if (this.isWho() == 'superadmin' && ! this.isEdit()) {
        //     this.initSuperadmin()
        // }
    },
    components:{
        DetailsCourier
    },
    methods: {
        async selectCourierList(data) {
                this.$refs.detailsCourier.fake_cost = 100
                const { courier_inter_rates, ...resLoad } = data
                const instance = ['allow_change_price', 'allow_change_rate', 'allow_change_service']
                instance.forEach((response) => {
                    if(resLoad[response] == 0) {
                        this.inputCourier.allowedCourier.push(response)
                    }
                })
                this.inputCourier.id = data.id
                this.inputCourier.descriptionCouier =  data.description,
                this.inputCourier.courierName = data.name,
                this.inputCourier.courierKey = data.courier_code,
                this.inputCourier.expired_date = data.expired_date,
                this.inputCourier.effective_date = data.effective_date
                this.inputCourier.price = courier_inter_rates[0].price
                this.inputCourier.price_min = courier_inter_rates[0].price_min
                this.inputCourier.rate_min = courier_inter_rates[0].rate_min
                this.inputCourier.rate = courier_inter_rates[0].rate
                this.inputCourier.rate_max_discount = courier_inter_rates[0].rate_max_discount
                this.inputCourier.service_min = courier_inter_rates[0].service_min
                this.inputCourier.service = courier_inter_rates[0].service
                this.inputCourier.selectCourierType = 'selectedLates'

                this.loader.busy = true;
                await this.$refs.detailsCourier.setUpVariable()
                this.loader.busy = false;
        },
        shippopOrSuperadmin() {
            return this.isWho() === 'shippop' || this.isWho() === 'superadmin'
        },
        async getCourierByIdAndRole() {
            this.loader.busy = true;
            await getCourierInterById( this.$route.params.Id ).then( dataCourier => {
                this.inputCourier.from_courier_inter = dataCourier.from_courier_inter ? dataCourier.from_courier_inter : null
                this.inputCourier.disable_edit_rate = dataCourier.is_edit_rate
                this.inputCourier.allowedCourier = dataCourier.allowedCourier
                this.inputCourier.courierKey = dataCourier.courierKey
                this.inputCourier.courierName = dataCourier.courierName
                this.inputCourier.descriptionCouier = dataCourier.descriptionCouier
                this.inputCourier.effective_date = dataCourier.effective_date
                this.inputCourier.expired_date = dataCourier.expired_date
                this.inputCourier.id = dataCourier.id
                this.inputCourier.effective_date  = dataCourier.effective_date
                this.inputCourier.expired_date =  dataCourier.expired_date
                this.inputCourier.nameOfPic = dataCourier.nameOfPic
                this.inputCourier.price = dataCourier.price
                this.inputCourier.price_min = dataCourier.price_min
                this.inputCourier.rate_min = dataCourier.rate_min
                this.inputCourier.rate = dataCourier.rate
                this.inputCourier.rate_max_discount = dataCourier.rate_max_discount
                this.inputCourier.service_min = dataCourier.service_min
                this.inputCourier.service = dataCourier.service
                this.loader.busy = false;
            }).catch(e => {
                showErrorModal( e )
                this.loader.busy = false;
            });
            // if(this.$USER_LOGIN.get().isSuperadmin) {
            this.$refs.detailsCourier.setUpVariable()
            // }else if(this.$USER_LOGIN.get().is)
        },
        initSuperadmin() {
            this.inputCourier.effective_date = moment().set({
                hour:0,minute:0
            }).format('YYYY-MM-DDTHH:mm')
        },
        reloadPage() {
            location.reload()
        },
        handleLoader() {
            this.loader.busy = !this.loader.busy
        },
        checkBtnConfirmData() {
            // validate ข้อมูลตอนกดปุ่มยืนยัน
            this.validateData.submitted = true
            this.$refs.detailsCourier.$v.inputCourier.$touch()
            this.checkCourierKeys()

            if (this.$refs.detailsCourier.$v.inputCourier.$invalid || !this.validateData.btnComfirm) {
                return false
            }

            if (this.isEdit()) {
                this.updateCourier()
            } else if (!this.isEdit() && this.isWho() === 'admin') {                
                this.adminAddCourier()
            } else {
                if (this.isWho() == 'shippop') {
                    this.shippopaddCourier()
                }
            }
        },
        adminAddCourier() {
            const headers = {
                headers: {
                    token: localStorage.getItem('access_token')
                }
            }
            const bodyJson = {
                from_courier_inter_id: this.inputCourier.id,
                price: this.inputCourier.price,
                price_min: this.inputCourier.price_min,
                service: this.inputCourier.service,
                service_min: this.inputCourier.service_min,
            }
            
            this.$http.post(this.$API_URL + `/inter/add/rate/shop`, bodyJson, headers).then((res) => {
                if(res.data.status) {
                    showConfirmSuccessModal('เพิ่มข้อมูลสำเร็จ')
                }
            }).catch(() => {
                showErrorModal('ไม่สามารถอัพเดท')
            })
        },
        shippopaddCourier() {            
            const headers = {
                headers: {
                    token: localStorage.getItem('access_token')
                }
            }
            const bodyJson = {
                from_courier_inter_id: this.isWho() === 'shippop' ? 0 : '',
                shop_id: this.isWho() === 'shippop' ? 0 : '',
                name: this.inputCourier.courierName,
                description: this.inputCourier.descriptionCouier,
                courier_code: this.inputCourier.courierKey,
                rate: this.inputCourier.rate,
                rate_min: this.inputCourier.rate_min,
                rate_max_discount: this.inputCourier.rate_max_discount,
                price: this.inputCourier.price,
                price_min: this.inputCourier.price_min,
                service: this.inputCourier.service,
                service_min: this.inputCourier.service_min,
                allow_change_rate: this.inputCourier.allowedCourier.includes('allow_change_rate') ? 0 : 1,
                allow_change_price: this.inputCourier.allowedCourier.includes('allow_change_price') ? 0 : 1,
                allow_change_service: this.inputCourier.allowedCourier.includes('allow_change_service') ? 0 : 1,
                effective_date: this.inputCourier.effective_date,
                expired_date: this.inputCourier.expired_date ? this.inputCourier.expired_date : null
            }
            this.$http.post(this.$API_URL + '/inter/set/courier', bodyJson, headers).then((res) => {
                if(res.data.status) {
                    this.modalSuccess('เพิ่มข้อมูลเรียบร้อยค่ะ', res.data.data.id)
                }
            })
        },
        // superadminGetCourierForUpdate() {
        //     console.log("i'm super admin get courier la ja")
        // },
        adminGetCourierForUpdate() {
        
        },
        adminUpdateCourier() {
            
        },
        updateCourier() {
            const headers = {
                headers: {
                    token: localStorage.getItem('access_token')
                }
            }           
            const bodyJson = {
                name: this.inputCourier.courierName,
                description: this.inputCourier.descriptionCouier,
                courier_code: this.inputCourier.courierKey,
                rate: this.inputCourier.rate,
                rate_min: this.inputCourier.rate_min,
                rate_max_discount: this.inputCourier.rate_max_discount,
                price: this.inputCourier.price,
                price_min: this.inputCourier.price_min,
                service: this.inputCourier.service,
                service_min: this.inputCourier.service_min,
                allow_change_rate: this.inputCourier.allowedCourier.includes('allow_change_rate') ? 0 : 1,
                allow_change_price: this.inputCourier.allowedCourier.includes('allow_change_price') ? 0 : 1,
                allow_change_service: this.inputCourier.allowedCourier.includes('allow_change_service') ? 0 : 1,
                effective_date: this.inputCourier.effective_date,
                expired_date: this.inputCourier.expired_date ? this.inputCourier.expired_date : null
            }
            
            this.$http.put(this.$API_URL + `/inter/update/rate/shop/${this.$route.params.Id}`, bodyJson, headers).then((res) => {
                if(res.data.status) {
                    showConfirmSuccessModal('แก้ไขข้อมูลสำเร็จ')
                }
            }).catch(() => {
                showErrorModal('ไม่สามารถอัพเดท')
            })
        },
        modalSuccess(msgBody, idCOurier = false) {
            this.$bvModal
                .msgBoxOk(msgBody, {
                    title: "SUCCESS",
                    size: "sm",
                    buttonSize: "sm",
                    okVariant: "success",
                    okTitle: "ตกลง",
                    contentClass: "modal-success",
                    headerClass: "p-2 border-bottom-0",
                    footerClass: "p-2 border-top-0",
                    centered: true
                })
                .then(value => {
                    if (value && idCOurier) {
                        this.$router.push(`/transport/inter/edit/${idCOurier}`)
                        // this.permission.samePage = true
                    } else {
                        window.location.reload();
                    }
                });
        },
        isEdit() {
            return !!this.$route.params.Id;
        },
        isWho() {
            return this.userLogin.role;
        },
        checkCourierKeys(eventChange = false) {
            let interKey = CourierRules.interCourierKey
            let key = this.inputCourier.courierKey

            this.inputCourier.nameOfPic = CourierRules.imageCourier[key] ? CourierRules.imageCourier[key] : ''

            if (key.length > 2 || eventChange) {
                if (key.includes('GEN', 'SPGEN')) {
                    this.validateData.btnComfirm = true
                    this.validateData.checkInput.courierKey = false
                } else {
                    if (interKey.includes(key)) {
                        this.validateData.btnComfirm = true
                        this.validateData.checkInput.courierKey = true
                    } else {
                        this.validateData.btnComfirm = false
                        this.validateData.checkInput.courierKey = false
                    }
                }
            } else {
                this.validateData.checkInput.courierKey = null
            }
        },
        updateCourierZone () {
            let key = this.inputCourier.courierKey
            let interCourierAll = CourierRules.interCourierKey

            this.checkCourierKeys()
        }
    },
    watch: {
        'permission.samePage': function () {
            window.location.reload()
        },
        'inputCourier.effective_date': function() {
             this.updateCourierZone()
        },
        'inputCourier.courierKey': function () {
            this.updateCourierZone()
        },
    }
}
</script>
